import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Order from './views/order/order.vue'
import orderReceived from './views/order/orderReceived.vue'
import orderDetails from './views/order/orderDetails.vue'
import myContract from './views/contract/index.vue'
import contractInfo from './views/contract/contractInfo.vue'
import budget from './views/budget/index.vue'
import budgetInfo from './views/budget/budgetInfo.vue'
import adContract from './views/contract/adContract.vue'
import appointment from './views/appointment/index.vue'
import contractList from './views/appointment/list.vue'
import myList from './views/appointment/myList.vue'
import make from './views/make/index.vue'
import login from './views/login/index.vue'
import info from './views/manInfo/info.vue'
import activityList from './views/activity/index.vue'
import activeInfo from './views/activity/activeInfo.vue'
import salesroom from './views/salesroom/index.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta:{
        title: '我的' 
      }
    },
    {
      path: '/order',
      name: 'order',
      component: Order,
      meta:{
        title: '全部订单' 
      }
    },
    {
      path: '/orderReceived',
      name: 'orderReceived',
      component: orderReceived,
      meta:{
        title: '待收货' 
      }
    },
    {
      path: '/orderDetails',
      name: 'orderDetails',
      component: orderDetails,
      meta:{
        title: '订单详情' 
      }
    },
    {
      path: '/myContract',
      name: 'myContract',
      component: myContract,
      meta:{
        title: '我的报修' 
      }
    },
    {
      path: '/contractInfo',
      name: 'contractInfo',
      component: contractInfo,
      meta:{
        title: '保修详情' 
      }
    },
    {
      path: '/budget',
      name: 'budget',
      component: budget,
      meta:{
        title: '我的预算' 
      }
    },
    {
      path: '/budgetInfo',
      name: 'budgetInfo',
      component: budgetInfo,
      meta:{
        title: '预算详情' 
      }
    },
    {
      path: '/adContract',
      name: 'adContract',
      component: adContract,
      meta:{
        title: '新增报修' 
      }
    },
    {
      path: '/appointment',
      name: 'appointment',
      component: appointment,
      meta:{
        title: '签订合同' 
      }
    },
    {
      path: '/contractList',
      name: 'contractList',
      component: contractList,
      meta:{
        title: '合同列表' 
      }
    },
    {
      path: '/myList',
      name: 'myList',
      component: myList,
      meta:{
        title: '我的合同' 
      }
    },
    {
      path: '/make',
      name: 'make',
      component: make,
      meta:{
        title: '我的预约' 
      }
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      meta:{
        title: '绑定手机号' 
      }
    },
    {
      path: '/info',
      name: 'info',
      component: info,
      meta:{
        title: '个人信息' 
      }
    },
    {
      path: '/activityList',
      name: 'activityList',
      component: activityList,
      meta:{
        title: '活动' 
      }
    },
    {
      path: '/activeInfo',
      name: 'activeInfo',
      component: activeInfo,
      meta:{
        title: '活动详情' 
      }
    },
    {
      path: '/salesroom',
      name: 'salesroom',
      component: salesroom,
      meta:{
        title: '周边门店' 
      }
    },
  ]
})
